import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Menu from './MovieMenu';

function MovieArea() {
  const [items, setItems] = useState(Menu);
  const filterItem = (categItem) => {
    const updatesItems = Menu.filter((curElem) => {

      return curElem.category === categItem;

    })

    setItems(updatesItems);
  }
  return (
    <section className="movie-area movie-bg" style={{ backgroundImage: 'url("../img/bg/movie_bg.jpg")' }}>
      <div className="container">
        <div className="row align-items-end mb-60">
          <div className="col-lg-6">
            <div className="section-title text-center text-lg-left">

              <h1 className="title">Why Choose Us?</h1>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">Expert Team</span>
                &nbsp;
                &nbsp;
                <p>Our team is composed of skilled professionals with years of experience in the film, web series, and advertising industries. From directors to editors, our experts are committed to delivering top-quality results that exceed expectations.</p>
              </div>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">Tailored Solutions</span>
                &nbsp;
                &nbsp;
                <p>We understand that every project is unique. That’s why we offer customized services that cater to your specific needs, whether you’re making a film, documentary, launching an ad campaign, or creating a web series. We work closely with you to ensure your vision is realized in the most impactful way possible.</p>
              </div>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">High-Quality Production</span>
                &nbsp;
                &nbsp;
                <p>We use the latest equipment and technology to deliver superior production quality, whether it's for a film, web series, or ad. From cameras and lighting to sound and editing software, we make sure your project stands out visually and creatively.</p>
              </div>
              <div>
                &nbsp;
                &nbsp;
                &nbsp;
                <span className="sub-title">End-to-End Services</span>
                &nbsp;
                &nbsp;
                <p>From pre-production planning and casting to filming and final edits, we offer a comprehensive, hands-on approach to every project. We manage every detail, allowing you to focus on your creative vision while we handle the logistics.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="movie-page-meta">
            </div>
          </div>
        </div>
        <div className="row">

        </div>
      </div>
    </section>
  )
}

export default MovieArea